<div class="sh-alert-wrapper">
    <div (click)="cancel()" class="sh-alert-wrapper__close" *ngIf="!data?.isClose">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path d="M22.4223 7L7 22.4223" stroke="#252828" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22.4223 22.4223L7 7" stroke="#252828" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
    <div class="sh-alert-wrapper__sh-icon">
       <img [src]="selectedSvg" alt="">
    </div>
    <div class="sh-alert-wrapper__sh-title">
        <h4>{{data.title}}</h4>
    </div>
    <div class="sh-alert-wrapper__sh-title">
        <p>{{data?.sub}}</p>
    </div>
    <div class="sh-alert-wrapper__sh-desc-container">
    <div class="sh-alert-wrapper__sh-desc">
        <!-- <p *ngIf="data.description.length == 1" class="no-bullet">{{data.description[0]}}</p> -->
        <ng-container *ngFor="let desc of data.description" >
        <p [ngClass]="{'no-bullet': data.description.length == 1}"  >{{desc}}</p>
    </ng-container>
    </div>
</div>
    <div class="sh-alert-wrapper__sh-actions">
            <button *ngIf="data?.cancelActionLabel" (click)="cancel()" class="scad-read-tab__tab">
               <div>{{data?.cancelActionLabel}}</div>
            </button>
            <button (click)="done()" class="scad-read-tab__tab active">
               <div>{{data?.okActionLabel}}</div>
            </button>
    </div>
</div>
